<template>
    <main class="l-main  main" v-bind:class="classes">
        <slot />
    </main>
</template>

<script>
    export default {
        name: 'app-main',
        props: {
            classes: {
                type: Object,
                default: () => ({})
            }            
        }
    }
</script>

<style scoped lang="scss">
</style>    


// WEBPACK FOOTER //
// src/components/Main.vue